import { createAction, props } from '@ngrx/store';
import { ComponentInfo } from '@ipensii/shared/domain-shared';

export class ComponentInfoActions {
  static readonly loadComponentInfo = createAction('[Shared - ComponentInfo] - Load Component Info');
  static readonly loadComponentInfoSuccess = createAction(
    '[Shared - ComponentInfo] - Load Component Info Success',
    props<{ componentInfo: ComponentInfo }>()
  );
  static readonly loadComponentInfoError = createAction(
    '[Shared - ComponentInfo] - Load Component Error',
    props<{ error: Error }>()
  );
}
